module.exports = "img/flags/LY.1ddc328.png";